import Screen from 'components/svg/screenz';
import Content from 'components/svg/content';
import Playlist from 'components/svg/playlist';

export enum PermissionsVariants {
  ScreensAccess = 'screensAccess',
  ContentAccess = 'contentAccess',
  PlaylistAccess = 'PlaylistAccess',
}

export const Variants = {
  [PermissionsVariants.ScreensAccess]: {
    icon: Screen,
    accessType: 'Screens Access',
    all: 'All screens',
    specific: 'Screens assigned to them only',
  },
  [PermissionsVariants.ContentAccess]: {
    icon: Content,
    accessType: 'Content Access',
    all: 'All content',
    specific: 'Content assigned to them only',
  },
  [PermissionsVariants.PlaylistAccess]: {
    icon: Playlist,
    accessType: 'Playlist Access',
    all: 'All playlists',
    specific: 'Playlists assigned to them only',
  },
};
